/* eslint-disable operator-linebreak */
import { Dispatch } from 'redux';
import { ISignin } from 'src/interfaces';
import signinService from 'src/services/signin.service';

import { AuthActionType } from '../action-types';
import { AuthAction } from '../actions';

export const signin = (signinData: ISignin) => async (dispatch: Dispatch<AuthAction>) => {
  dispatch({
    type: AuthActionType.SIGNIN,
  });

  try {
    const { data } = await signinService.signin(signinData);

    const { accessToken, permissions, companies } = data;

    dispatch({
      type: AuthActionType.SIGNIN_SUCCESS,
      payload: { accessToken, permissions, companies },
    });
  } catch (err: any) {
    dispatch({
      type: AuthActionType.SIGNIN_FAILURE,
      payload: err.message,
    });
  }
};
